import { render } from "./CardExpenses.vue?vue&type=template&id=4a068b9d&scoped=true"
import script from "./CardExpenses.vue?vue&type=script&lang=js"
export * from "./CardExpenses.vue?vue&type=script&lang=js"

import "./CardExpenses.vue?vue&type=style&index=0&id=4a068b9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a068b9d"]])

export default __exports__